import styled from 'styled-components';

export const FlexTimeWrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
